/*eslint import/no-unresolved: [2, { ignore: ['csv-parse$'] }]*/
import parse from 'csv-parse';
export const useCsvParser = ({ input, parseOptions, callback, }) => {
    const csvParseOptions = parseOptions || {
        columns: true,
        trim: true,
        skipEmptyLines: true,
        skipLinesWithError: true,
    };
    return input
        ? parse(input, csvParseOptions, callback)
        : parse(csvParseOptions);
};
export default useCsvParser;
